import React from 'react';
import PropTypes from 'prop-types';

const QuestionLabel = ({ label, theme, id, customLabelClass }) => {
  const labelClass = theme === 'horizontal' ? 'inline-block' : 'block';

  return label ? <label
    className={`${labelClass} tracking-wide text-gray-700 text-xs font-bold mb-2 ${customLabelClass}`}
    htmlFor={id}>
    {label}
  </label> : null;
};

QuestionLabel.propTypes = {
  customLabelClass: '',
}

QuestionLabel.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  theme: PropTypes.string,
  customLabelClass: PropTypes.string,
}

export default QuestionLabel;
